<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="收入项名称/支付方名称" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addIncomeModal=true">添加收入项</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <add-income-modal v-model="addIncomeModal" @on-success="onSuccess"></add-income-modal>
    <income-detail-modal v-model="incomeDetailModal" :initValue="incomeDetailId"
                         @on-success="onModifySuccess"></income-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import AddIncomeModal from '@/view/fm/components/add-income-modal'
import IncomeDetailModal from '@/view/fm/components/income-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'incomes',
  components: {
    AddIncomeModal,
    IncomeDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      payTypeFilter: null,

      // 添加收入项
      addIncomeModal: false,

      // 收入项详细信息
      incomeDetailModal: false,
      incomeDetailId: null,

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '收入项名称',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          width: 200
        },
        {
          title: '支付方名称',
          resizable: true,
          key: 'payer',
          ellipsis: 'true',
          width: 200
        },
        {
          title: '收款总额',
          resizable: true,
          sortable: 'custom',
          key: 'total',
          ellipsis: 'true',
          width: 160,
          render: function (h, params) {
            return h('div', '￥' + numberFormat(params.row.total))
          }
        },
        {
          title: '支付方式',
          resizable: true,
          key: 'payType',
          ellipsis: 'true',
          width: 120,
          filters: [
            {
              label: '银行转账',
              value: 1
            },
            {
              label: '现金支付',
              value: 2
            },
            {
              label: '网络支付',
              value: 3
            }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.payTypeFilter = genQueryParam('payType', 'EQ', val[0])
            } else {
              this.payTypeFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.payType) {
              if (params.row.payType === 1) {
                return h('div', '银行转账')
              } else if (params.row.payType === 2) {
                return h('div', '现金支付')
              } else if (params.row.payType === 3) {
                return h('div', '网络支付')
              }
            }
          }
        },
        {
          title: '收款时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'occurrenceDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.occurrenceDatetime) {
              let d = new Date(params.row.occurrenceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.incomeDetailId = params.row.id
                    this.incomeDetailModal = true
                  }
                }
              }, '详细信息')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'IncomeServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null
      let queryParams = []

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.payTypeFilter) {
        queryParams.push(this.payTypeFilter)
      }

      store.dispatch('IncomeServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam,
          q: queryParams
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_Income_GetPageResult) {
        return store.getters.get_Income_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_Income_GetPageResult) {
        return store.getters.get_Income_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_Income_GetPageResult) {
        return store.getters.get_Income_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
